/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LogonLevel = 'user' | 'operator' | 'installer';

export const LogonLevel = {
    User: 'user' as LogonLevel,
    Operator: 'operator' as LogonLevel,
    Installer: 'installer' as LogonLevel
};

